<template>
  <AppHeader variant="transparent" />
  <OurMission />
  <AppFooter />
</template>

<script>
import AppHeader from "@/components/common/Header.vue";
import OurMission from "@/components/content/OurMission.vue";
import AppFooter from "@/components/common/Footer.vue";

export default {
  name: "HomePage",
  components: {
    AppHeader,
    OurMission,
    AppFooter,
  },
};
</script>

<style></style>
